import type { RootStoreState } from "@store/types";

export const selectItemsCount = (state: RootStoreState): number =>
  state.cart.items.reduce((count, { quantity }) => count + quantity, 0);
